import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';

const CTA: React.FC = () => {
  return (
    <div className='cta-container'>
      <Link to='/request-account' className='cta-button'>
        Request an Athena for Partners Account
      </Link>
      <div className='faq-container'>
        <a
          href='./assets/Athena_FAQs.pdf'
          className='cta-footer-link'
          target='_blank'
          rel='noopener noreferrer'
        >
          FAQ
        </a>
      </div>
    </div>
  );
};

export default CTA;
